import { Grid, styled } from '@mui/material'
import { GridContainer } from '../Grid/GridContainer'
import { FOOTER_HEIGHT, PAGE_MAX_WIDTH, PAGE_WIDTH } from '../../theme'
import { Separator } from '../styles/Typography.styled'
import { mobile, tablet } from '../../utils/breakpoints'

export const FooterWrapper = styled('footer')`
  background-color: ${({ theme }) => theme.palette.branding.footerBackground};
  height: ${FOOTER_HEIGHT.desktop};
  align-content: center;
  overflow-x: hidden;
  padding: 30px 0;
  box-sizing: border-box;

  ${({ theme }) => mobile(theme, { height: FOOTER_HEIGHT.mobile })}
  ${({ theme }) => tablet(theme, { height: FOOTER_HEIGHT.tablet })}
`

export const FooterContent = styled(GridContainer)`
  width: ${PAGE_WIDTH.desktop};
  max-width: ${PAGE_MAX_WIDTH.desktop};
  margin: 0 auto;
  align-items: flex-end;
  ${({ theme }) =>
    mobile(theme, {
      display: 'flex',
      'flex-direction': 'column',
      'align-items': 'center',
      'justify-content': 'space-between',
      gap: 0,
      height: '100%',
    })}

  ${({ theme }) =>
    tablet(theme, {
      display: 'flex',
      'flex-direction': 'column',
      'align-items': 'flex-start',
      gap: 0,
    })}
`

export const RightGrid = styled(Grid)`
  ${({ theme }) => tablet(theme, { 'align-self': 'flex-end' })}
`

export const FooterSeparator = styled(Separator)`
  background-color: ${({ theme }) => theme.palette.branding.footerText};
`
